<template>
    <div class="submain">
        <h1>我的收藏夹</h1>
        <div class="content">
            <div class="flexbox top">
                <div class="left">
                    <el-checkbox v-model="allcol" @change="selAll('all', allcol)">全选</el-checkbox>
                    <el-button type="danger" @click="delCol('array', '')">删除</el-button>
                </div>
                <div class="right">您共收藏了<span class="redw">{{ totalNum }}</span>个商品</div>
            </div>
            <div class="con">
                <div class="flexbox item" v-for="(item, index) in collections" :key="index">
                    <div class="flexbox left">
                        <el-checkbox v-model="item.sel" @change="selAll('sig', item.sel)"></el-checkbox>
                        <div class="flexbox goodsmsg">
                            <div class="img"><img :src="item.MGM_GOODSPIC_MAIN"></div>
                            <div class="msg">
                                <p class="name">{{item.MGM_LONG_DESC}}</p>
                                <!-- <span class="redw">¥ {{item.MONEY}}</span> -->
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <el-button plain @click="pageToDetail(index)">查看详情</el-button>
                        <el-button plain @click="delCol('single', index)">删除</el-button>
                    </div>
                </div>
            </div>
            <div class="pages">
                <el-pagination @current-change="handleCurrentChange" 
                v-model:currentPage="currentPage" :page-size="20" :total="totalNum" 
                layout="prev, pager, next, jumper" background></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, reactive, toRefs, getCurrentInstance, onBeforeMount } from 'vue'
    import { useRouter } from 'vue-router'
    import { ElMessage } from 'element-plus'
    import config from '@/api/config.js' 

    export default {
        name: 'MyCollection',
        components: {
            
        },
        setup() {
            let { proxy } = getCurrentInstance()
            let router = useRouter()
            let baseImgUrl = config.baseImgUrl
            let totalNum = ref(0)
            let pageData = reactive({
                collections: null, // 收藏列表
                colArr: [], // 要删除的收藏
            })
            // 全选
            let allcol = ref(false)
            let selAll = (type, val) => {
                if(type == 'all' && val == true) {
                    pageData.collections.map(item => {
                        item.sel = true
                    })
                }else if (type == 'all' && val == false) {
                    pageData.collections.map(item => {
                        item.sel = false
                    })
                }else if (type == 'sig' && val == false) {
                    allcol.value = false
                }else if (type == 'sig' && val == true) {
                    allcol.value = true
                    pageData.collections.map(item => {
                        if(!item.sel) {
                            allcol.value = false
                        }
                    })
                }
                
            }
            // 获取收藏列表
            let getCollection = () => {
                let data = {
                    postType: 'querycollection',	
                    start: currentPage.value, // 页码	
                    limit: '20', // 每页条数
                }
                proxy.$axios.postReq('/meide/REST/ajaxMdCollection', data)
                .then(res => {
                    if(res.success == 'true') {
                        if(res.items) {
                            res.items.map(item => {
                                item.sel = false
                                // item.MGM_GOODSPIC_MAIN = baseImgUrl + item.MGM_GOODSPIC_MAIN
                            })
                        }
                        pageData.collections = res.items
                        totalNum.value = parseInt(res.rowcount)
                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            // 分页
            let currentPage = ref(1)
            let handleCurrentChange = (val) => {
                currentPage.value = val
                getCollection()
            }
            // 删除
            let delClick = ref(true)
            let delCol = (type, idx) => {
                if(type == 'single') {
                    let col = {
                        PZ: pageData.collections[idx].MGM_GOODS_JPPZID,
                        XS: pageData.collections[idx].MGM_GOODS_XSISSPLIT,
                        CZ: pageData.collections[idx].MGM_GOODS_CZID
                    }
                    pageData.colArr.push(col)
                }else {
                    for(let i = 0; i < pageData.collections.length; i ++) {
                        if(pageData.collections[i].sel) {
                            pageData.colArr.push({
                                PZ: pageData.collections[i].MGM_GOODS_JPPZID,
                                XS: pageData.collections[i].MGM_GOODS_XSISSPLIT,
                                CZ: pageData.collections[i].MGM_GOODS_CZID
                            })
                        }
                    }
                }
                delCollection()
            }
            let delCollection = () => {
                if(delClick.value) {
                    if(pageData.colArr.length < 1) {
                        ElMessage.error('请先选择至少一个收藏')
                        return
                    }
                    delClick.value = false
                    proxy.$alert('确认删除收藏吗？', '提示', {
                        confirmButtonText: '确定',
                        showCancelButton: true,
                        callback: action => {
                            if(action == 'confirm') {
                                let data = {
                                    postType: 'delete',	
                                    delids: pageData.colArr
                                }
                                proxy.$axios.postReq('/meide/REST/ajaxMdCollection', data)
                                .then(res => {
                                    if(res.success == 'true') {
                                        ElMessage.success({
                                            message: res.Info,
                                            type: 'success'
                                        });
                                        delClick.value = true
                                        getCollection()
                                        pageData.colArr = []
                                    }else {
                                        proxy.$alert(res.ErrorText, '提示', {
                                            confirmButtonText: '确定',
                                            callback: action => {}
                                        });
                                    }
                                }).catch(error => {
                                    proxy.$alert(error, '提示', {
                                        confirmButtonText: '确定',
                                        callback: action => {}
                                    });
                                })
                            }
                        }
                    })
                }
            }
            // 跳转详情
            let pageToDetail = (idx) => {
                router.push({
                    name: 'ProductDetails',
                    query: {
                        pz: pageData.collections[idx].MGM_GOODS_JPPZID,
                        cz: pageData.collections[idx].MGM_GOODS_CZID,
                        xs: pageData.collections[idx].MGM_GOODS_XSISSPLIT,
                        field: pageData.collections[idx].FIELD,
                    }
                })
            }

            onBeforeMount(() => {
                getCollection()
            })


            return {
                ...toRefs(pageData),
                allcol,
                selAll,
                getCollection,
                currentPage,
                totalNum,
                handleCurrentChange,
                delClick,
                delCol,
                delCollection,
                pageToDetail
            }
        }
    }
</script>

<style scoped lang="scss">
    .submain {
        padding: 10px;
        background: #fff;
        h1 {
            font-size: 16px;
            padding: 10px 0;
            border-bottom: 1px solid rgba(223, 223, 223, 1);
        }
        .content {
            padding-bottom: 20px;
            .top {
                padding: 20px 10px;
                border-bottom: 1px solid rgba(242, 242, 242, 1);
                justify-content: space-between;
                .left {
                    ::v-deep(.el-button--danger) {
                        height: 30px;
                        margin-left: 20px;
                    }
                }
                .right {
                    font-size: 12px;
                    .redw {
                        font-size: 12px;
                    }
                }
            }
            .con {
                margin-bottom: 25px;
                .item {
                    justify-content: space-between;
                    padding: 20px 10px;
                    border-bottom: 1px solid rgba(242, 242, 242, 1);
                    .left {
                        .goodsmsg {
                            .img {
                                width: 80px;
                                height: 80px;
                                margin: 0 15px;
                                padding: 10px;
                                img {
                                    width: 60px;
                                    height: 60px;
                                }
                            }
                            .msg {
                                .name {
                                    font-size: 12px;
                                    margin-bottom: 10px;
                                }
                                .redw {}
                            }
                        }
                    }
                    .right {
                        ::v-deep(.el-button) {
                            height: 30px;
                            width: 87px;
                            display: block;
                            margin: 10px 0;
                            font-size: 12px;
                        }
                    }
                }
            }
            .pages {}
        }
    }
</style>